/**
 * Уведомление о cookie.
 *
 * Уведомление, а не запрос согласия: сайт ставит только необходимую cookie
 * сессии, а reCAPTCHA работает лишь на формах входа и регистрации. Отказаться
 * здесь не от чего, поэтому кнопка одна, а подробности — в разделе политики.
 *
 * Плашка в правом нижнем углу и узкая: левый нижний угол карты занят
 * логотипом Яндекса, закрывать который нельзя по условиям их API. На экране
 * раунда её нет вовсе — там она легла бы поверх карты посреди игры.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

const STORAGE_KEY = "chronoguessr:cookie-notice";

function alreadySeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    // Хранилище закрыто — показать уведомление лишний раз не страшно.
    return false;
  }
}

export function CookieNotice() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(alreadySeen);

  if (hidden || pathname.startsWith("/play/")) return null;

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // Не запомнилось — уведомление вернётся в следующий заход, и только.
    }
    setHidden(true);
  };

  return (
    <div
      role="region"
      aria-label={t("cookies.label")}
      className="panel fixed inset-x-3 bottom-3 z-50 flex flex-col gap-3 p-4 text-sm text-ink-200
                 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-sm"
    >
      <p className="leading-relaxed">
        {t("cookies.text")}{" "}
        <Link to="/privacy#cookies" className="text-amber-300 underline underline-offset-2 hover:text-amber-200">
          {t("cookies.more")}
        </Link>
      </p>
      <button type="button" onClick={accept} className="btn-primary self-end">
        {t("cookies.ok")}
      </button>
    </div>
  );
}
